import { createContext } from 'react';

// ----------------------------------------------------------------------

export const QuickBookContext = createContext({});